// extracted by mini-css-extract-plugin
export default {"container":"userAvatar_container__Jdw8z","action":"userAvatar_action__Kfgb8","circle":"userAvatar_circle__xxarc","avatarText":"userAvatar_avatarText__-335-"};